import { Container, Modal, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setHideSignInUp, setOwnUser, setShowConfirm, setUser } from '../../../../redux/user/user.actions';
import './SignInUp.scss';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import Amplify, { Auth, Hub } from 'aws-amplify';
import { AWS_CONFIG } from '../../../../aws-config/aws-config';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import Login from './Login/Login';
import Confirm from './Confirm/Confirm';
import SignUp from './SignUp/SignUp';
import ForgotPassword from './ForgotPassword/ForgotPassword';
import NewPassword from './ForgotPassword/NewPassword';
import { UrbainUser } from '../../../../redux/user/user.types';
import { isEmpty } from '../../../../utils/utils';
import { useHistory } from 'react-router-dom';
import { toast } from '../../../toaster/toast';
export const JWT_SESSION_STORAGE = 'urbainJWT';
Amplify.configure(AWS_CONFIG);

interface SignInUpProps {
  openLogin: boolean;
  openSignUp: boolean;
  setHideSignInUp: Function;
  setUser: Function;
  setOwnUser: Function;
  urbainUser: UrbainUser;
  showConfirm: boolean;
  setShowConfirm: Function;
}

function SignInUp({ openLogin, openSignUp, setHideSignInUp, setUser, setOwnUser, urbainUser, showConfirm, setShowConfirm }: SignInUpProps) {
  const [isLogin, setIsLogin] = useState(true);
  const [isSignUp, setIsSignUp] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [isNewPassword, setIsNewPassword] = useState<any>(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [username, setUsername] = useState<string>();
  const history = useHistory();

  useEffect(() => {
    if (openLogin) {
      changeToLogin();
    }
  }, [openLogin]);

  useEffect(() => {
    if (openSignUp) {
      changeToSignUp();
    }
  }, [openSignUp]);

  useEffect(() => {
    if (showConfirm) {
      changeToConfirm();
    }
  });

  const changeToLogin = (username?: string) => {
    setIsLogin(true);
    setIsConfirm(false);
    setIsSignUp(false);
    setIsForgotPassword(false);
    setIsNewPassword(false);
    setUsername(username);
  };

  const changeToForgotPassword = () => {
    setIsLogin(false);
    setIsConfirm(false);
    setIsSignUp(false);
    setIsForgotPassword(true);
    setIsNewPassword(false);
  };

  const changeToSignUp = () => {
    setIsLogin(false);
    setIsConfirm(false);
    setIsSignUp(true);
    setIsForgotPassword(false);
    setIsNewPassword(false);
  };

  const changeToConfirm = () => {
    setIsLogin(false);
    setIsConfirm(true);
    setIsSignUp(false);
    setIsForgotPassword(false);
    setIsNewPassword(false);
  };

  const changeToNewPassword = (username: string) => {
    setIsLogin(false);
    setIsConfirm(false);
    setIsSignUp(false);
    setIsForgotPassword(false);
    setIsNewPassword(true);
    setUsername(username);
  };

  const setUserAndClose = (user: any) => {
    setUser(user);
    if (user) {
      localStorage.setItem(JWT_SESSION_STORAGE, user?.signInUserSession?.idToken?.jwtToken);
    } else {
      localStorage.removeItem(JWT_SESSION_STORAGE);
    }
    if (user && user.attributes.sub && (!urbainUser || (urbainUser && isEmpty(urbainUser)))) {
      setOwnUser(user.attributes.sub);
    } else {
      setOwnUser();
    }
    hideSignInModal();
  };

  const hideSignInModal = () => {
    setShowConfirm(false);
    reset();
    changeToLogin();
    setHideSignInUp();
  };

  const redirectTo = () => {
    if (window.localStorage.getItem('redirectUrl')) {
      history.push(`${window.localStorage.getItem('redirectUrl')}`);
      window.localStorage.removeItem('redirectUrl');
    }
  };

  useEffect(() => {
    Hub.listen('auth', ({ payload: { event, data } }) => {
      switch (event) {
        case 'signIn':
        case 'customOAuthState':
          setUserAndClose(data);
          break;
        case 'signOut':
          redirectTo();
          setUserAndClose(null);
          break;
      }
    });

    Auth.currentAuthenticatedUser()
      .then(user => {
        redirectTo();
        setUserAndClose(user);
      })
      .catch(() => console.log('Not signed in'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const { reset } = useForm();

  const onFacebookSubmit = async () => {
    try {
      window.localStorage.setItem('redirectUrl', window.location.pathname + window.location.search);
      const data: any = await Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Facebook });
    } catch (error: any) {
      toast.error(error.message);
      console.log('error signing up:', error);
    }
  };

  const onGoogleSubmit = async () => {
    try {
      window.localStorage.setItem('redirectUrl', window.location.pathname + window.location.search);
      const data: any = await Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google });
    } catch (error) {
      console.log('error signing up:', error);
    }
  };

  return (
    <Modal
      show={openLogin || openSignUp}
      onHide={hideSignInModal}
      size="lg"
      backdrop="static"
      keyboard={false}
      aria-labelledby="contained-modal-title-vcenter sign-in-up-modal"
      centered
      className="sign-in-up-modal p-0 transparent-background"
      dialogClassName={isLogin ? 'cut-corner' : ''}
    >
      <Modal.Body>
        <Container className="sign-in-up-modal-container p-0">
          <Row className="m-0">
            {isForgotPassword && (
              <ForgotPassword
                changeToLogin={changeToLogin}
                changeToNewPassword={changeToNewPassword}
                username={username}
                hideSignInModal={hideSignInModal}
              />
            )}
            {isConfirm && (
              <Confirm changeToLogin={changeToLogin} username={username} hideSignInModal={hideSignInModal} setShowConfirm={setShowConfirm} />
            )}
            {isLogin && (
              <Login
                changeToForgotPassword={changeToForgotPassword}
                changeToSignUp={changeToSignUp}
                onFacebookSubmit={onFacebookSubmit}
                onGoogleSubmit={onGoogleSubmit}
                username={username}
                hideSignInModal={hideSignInModal}
              />
            )}
            {isSignUp && (
              <SignUp
                onGoogleSubmit={onGoogleSubmit}
                onFacebookSubmit={onFacebookSubmit}
                changeToConfirm={changeToConfirm}
                changeToLogin={changeToLogin}
                setUsername={setUsername}
                hideSignInModal={hideSignInModal}
              />
            )}
            {isNewPassword && <NewPassword changeToLogin={changeToLogin} username={username} hideSignInModal={hideSignInModal} />}
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    setHideSignInUp: () => dispatch(setHideSignInUp()),
    setUser: (data: any) => dispatch(setUser(data)),
    setOwnUser: (userId: string) => dispatch(setOwnUser(userId)),
    setShowConfirm: (value: boolean) => dispatch(setShowConfirm(value))
  };
};

const mapStateToProps = (state: any) => ({
  openLogin: state.user.showSignInUp.login,
  openSignUp: state.user.showSignInUp.signUp,
  showConfirm: state.user.showConfirm,
  urbainUser: state.user.urbainUser
});

export default connect(mapStateToProps, mapDispatchToProps)(SignInUp);
